import React from 'react';
import { styled } from "@mui/styles";

const StyledOnBoardingFooter = styled('div')(({ theme }) => ({
    textAlign: 'center',

    '& .onboarding-navigation': {
        margin: '0 auto',
    },

    '& .onboarding-navigation-dot': {
        display: 'inline-block',
        margin: '0 5px',
        cursor: 'pointer',
        color: 'var(--siteconfig-ui-btn-stdcolor-rgba)',
    },

    '& .onboarding-actions': {
        display: 'flex',
        justifyContent: 'end',
    }
}));

const OnBoardingFooter = ({
    childCount,childSlides,
    currentSlide,
    setCurrentSlide,
    handleComplete,
    handleSkip
}) => {
    return (
        <StyledOnBoardingFooter className="grid-x">
            <div className="cell small-3"></div>
            <div className="cell small-6">
                {childCount > 1 && <>
                    <div className="onboarding-navigation">
                        {childSlides.map((slide, index) => (
                            <React.Fragment key={index}>
                                {(index === currentSlide) &&
                                    <div className="onboarding-navigation-dot">
                                        <i className="fa fa-circle"></i>
                                    </div>
                                }

                                {(index !== currentSlide) &&
                                    <div className="onboarding-navigation-dot">
                                        <i className="fa fa-circle-thin"
                                           onClick={e => setCurrentSlide(index)}
                                        ></i>
                                    </div>
                                }
                            </React.Fragment>
                        ))}
                    </div>

                    {(currentSlide < (childCount - 1)) &&
                        <button
                            type="button"
                            className="button secondary clear onboarding-skip margin-bottom-0"
                            onClick={e => handleSkip()}
                        >
                            Skip for now
                        </button>
                    }
                </>}
            </div>
            <div className="cell small-3">
                <div className="onboarding-actions">
                    {currentSlide === (childCount - 1) && <>
                        <button
                            type="button"
                            className="button primary onboarding-get-started margin-bottom-0"
                            onClick={e => handleComplete()}
                        >
                            Get Started
                        </button>
                    </>}
                </div>
            </div>
        </StyledOnBoardingFooter>
    )
}

export default OnBoardingFooter;
